<template>
  <div class="summary">
    <header class="header item-header">
      <div class="core-detail">
        <h2>
          Booking summary
        </h2>
      </div>
    </header>

    <div
      v-if="hotelItem"
      class="summary-section"
    >
      <h3>{{ hotelItem.hotel_name }}</h3>
      <p>Guests: <strong>{{ hotelItem.count_pax }}</strong></p>
      <p>Rooms: <strong>{{ roomsText }}</strong></p>
    </div>

    <h3>
      {{ spaItemTitle }}
    </h3>

    <p>
      Booking reference: <strong>{{ booking.reference }}</strong>
      <strong v-if="anyCancellations"> - Has Cancellation</strong>
    </p>
    <p>
      Booking date: <strong>{{ formattedBookingDate }}</strong>
    </p>
    <p v-if="salesAgentText">
      Sales Agent: <strong>{{ salesAgentText }}</strong>
    </p>
    <p v-if="bookingMethodText">
      Booking Type: <strong>{{ bookingMethodText }}</strong>
    </p>
    <p v-if="offerText">
      Special Offers: <strong>{{ offerText }}</strong>
    </p>
  </div>
</template>

<script>
import { date } from 'lib/date-and-time-formats'

export default {
  props: {
    itineraryItems: {
      type: Array,
      required: true
    },
    booking: {
      type: Object,
      required: true,

      reference: {
        type: String,
        required: true
      },

      sales_agent: {
        type: String,
        default: null
      }
    }
  },

  computed: {
    anyCancellations () {
      return this.itineraryItems.filter((ii) => ii.deleted_at !== null).length > 0
    },

    formattedBookingDate () {
      return date(this.booking.booking_date)
    },

    hotelItem () {
      return this.itineraryItems.filter((ii) => ii.type === 'hotel')[0]
    },

    spaItem () {
      return this.itineraryItems.filter((ii) => ii.type === 'spa')[0]
    },

    spaItemTitle () {
      if (this.hotelItem) {
        return 'Spabreaks.com details'
      } else {
        return this.spaItem.supplier_name
      }
    },

    roomsText () {
      const counts = this.hotelItem.rooms.reduce((acc, room) => {
        acc[room.type] = (acc[room.type] || 0) + 1
        return acc
      }, {})

      return Object.entries(counts).map((roomCount) =>
        `${roomCount[1]} × ${roomCount[0]} ${this.cancellationText(this.hotelItem)}`
      ).join(', ')
    },

    salesAgentText () {
      if (!this.booking || !this.validSalesAgent(this.booking.sales_agent)) return null
      const sa = this.booking.sales_agent

      return [sa.first_name, sa.surname, sa.phone_number].filter(x => !!x).join(' ')
    },

    bookingMethodText () {
      if (!this.booking || !this.booking.booking_method) return null

      return this.booking.booking_method
    },

    offerText () {
      if (!this.booking || !this.booking.offers) return null

      return this.booking.offers.join(', ')
    }
  },

  methods: {
    cancellationText (item) {
      return item.deleted_at ? 'CANCELLATION ' : ''
    },

    validSalesAgent (sales_agent) {
      return sales_agent && sales_agent.first_name !== 'Online'
    }
  }
}
</script>
